import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { Area } from '@src/main/modules/common/area/domain/Area';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';

import { useAreas } from '@src/main/ui/components/Areas/hooks/useAreas';
import DashboardsList from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardsList';
import DashboardsModal from '@src/main/ui/components/common/Dashboard/DashboardModal/DashboardModal';
import { NotFoundPage } from '@src/main/ui/components/common/NotFoundPage/NotFoundPage';
import styles from './Areas.module.scss';

const Areas: FC = () => {
  const { areas } = useAreaContext();
  const { areaId, subareaId } = useParams();
  const { subarea, subsubareas, subsubareaSelected, setSubsubareaSelected } = useAreas({
    areas,
    areaId,
    subareaId,
  });

  return (
    <>
      {areas && !subarea && <NotFoundPage />}
      {areas && subarea && (
        <>
          <Typography variant="h3" sx={{ paddingRight: '40px' }}>
            {areaId && subareaId && getTitleArea(areaId, subareaId, areas)}
          </Typography>
          <Box className={styles.tab}>
            {subsubareas.map((subsubarea) => (
              <Box
                className={`${styles.tab__item} ${
                  subsubareaSelected?.id === subsubarea.id && styles.tab__itemSelected
                }`}
                onClick={() => {
                  if (subsubareaSelected && subsubareaSelected.id === subsubarea.id) {
                    setSubsubareaSelected(undefined);
                  } else setSubsubareaSelected(subsubarea);
                }}
                key={subsubarea.id}
              >
                <Typography>{subsubarea.name}</Typography>
                <Typography className={styles.tab__item__badge}>
                  {subsubarea.dashboards.length}
                </Typography>
              </Box>
            ))}
          </Box>
          {subsubareaSelected?.dashboards && (
            <DashboardsList
              isExpandable={false}
              title={subsubareaSelected.name}
              dashboards={subsubareaSelected.dashboards}
              actions={{
                favorite: true,
                info: true,
              }}
            />
          )}
          {!subsubareaSelected && (
            <>
              {subsubareas.map((subsubarea) => (
                <DashboardsList
                  key={subsubarea.id}
                  isExpandable={false}
                  dashboards={subsubarea.dashboards}
                  title={subsubarea.name}
                  actions={{
                    favorite: true,
                    info: true,
                  }}
                />
              ))}
            </>
          )}
          <DashboardsModal />
        </>
      )}
    </>
  );
};

const getTitleArea = (areaId: string, subareaId: string, areas: Area[]): string => {
  const areaFound = areas.find((area) => area.id === areaId);
  const areaName = areaFound?.name || '';
  const subareaName = areaFound?.subareas.find((subarea) => subarea.id === subareaId)?.name;
  return `${areaName} - ${subareaName}`;
};

export default Areas;
